var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"elevation":"0"}},[_c('v-card-title',{staticClass:"pb-0"},[_c('header-tab-admin')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('main-card-admin')],1)],1),_vm._v(" "),_c('errors-alert')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }